import { render, staticRenderFns } from "./jituanzongbu.vue?vue&type=template&id=108c63a3&scoped=true"
import script from "./jituanzongbu.vue?vue&type=script&lang=js"
export * from "./jituanzongbu.vue?vue&type=script&lang=js"
import style0 from "./jituanzongbu.vue?vue&type=style&index=0&id=108c63a3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108c63a3",
  null
  
)

export default component.exports